import React, { useState } from "react";
import { checkSaralIdIsExist } from "../../Utils/APIs/checkSaralIdIsExistAPI.js";
const FarmerExpired = () => {
  const [saralId, setSaralId] = useState();
  const [farmerDetails, setFarmerDetails] = useState({});
  const [farmerExist, setFarmerExist] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const isExistSaralId = async () => {
    await checkSaralIdIsExist(
      saralId,
      setFarmerDetails,
      setFarmerExist,
      setResponseMessage
    );
  };
  const handleComplaintForm = async (e) => {
    e.preventDefault();
  };
  return (
    <div className="w-full h-full flex flex-col overflow-y-scroll">
      <div className="mainHeading">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg">
          F<span className="text-lg">ARMER</span> E
          <span className="text-lg">XPIRE</span>
        </h1>
      </div>
      <div className="grid gap-3 m-6 md:grid-cols-4">
        <div>
          <label
            for="saral_id"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            Saral ID<span className="text-red-500 relative h-3">*</span>
          </label>
          <input
            type="text"
            id="saral_id"
            onChange={(e) => {
              setSaralId(e.target.value);
            }}
            value={saralId}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
            placeholder="Saral Id"
            required
          />
        </div>
        <div>
          {saralId && (
            <button
              type="button"
              onClick={isExistSaralId}
              className="text-white mt-7 bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
            >
              Find
            </button>
          )}
        </div>
        <div>
          <h1
            className="text-2xl tracking-widest "
            style={{
              color:
                responseMessage === "Farmer Exist"
                  ? "rgb(0, 250, 0)"
                  : "rgb(255, 0, 0)",
            }}
          >
            {responseMessage}
          </h1>
        </div>
      </div>
      {farmerDetails && Object.keys(farmerDetails).length > 0 ? (
        <table className=" table-relative bg-white border mx-6 border-gray-300 rounded-lg">
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              Saral Id:
            </th>{" "}
            <td className="text-gray-700">{farmerDetails?.saralId}</td>{" "}
            <th className="text-left pl-6 text-gray-600 font-semibold">
              Warranty Expired Date :
            </th>
            <td className="text-gray-700 text-red-600">
              {farmerDetails.warrantyExpiredDate}
            </td>
          </tr>
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              Farmer:
            </th>{" "}
            <td className="text-gray-700">{farmerDetails.farmerName}</td>{" "}
            <th className="text-left pl-6 text-gray-600 font-semibold">
              Coordinates :
            </th>
            <td className="text-gray-700">
              {farmerDetails.longitude + "," + farmerDetails.latitude}
            </td>
          </tr>
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              Contact_No.{" "}
            </th>{" "}
            <td className="text-gray-700 select-none pointer-events-none">
              {farmerDetails.contact}
            </td>
            <th className="text-left pl-6 text-gray-600 font-semibold">
              Installation Date :
            </th>
            <td className="text-gray-700">{farmerDetails.installationDate}</td>
          </tr>
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              State :
            </th>
            <td className="text-gray-700">{farmerDetails.state}</td>
            <th className="text-left pl-6 text-gray-600 font-semibold">
              Department :
            </th>
            <td className="text-gray-700">{farmerDetails.department}</td>
          </tr>
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              District :
            </th>
            <td className="text-gray-700">{farmerDetails.district}</td>
            <th className="text-left pl-6 text-gray-600 font-semibold">
              Product :
            </th>
            <td className="text-gray-700">
              {farmerDetails.HP + "HP " + farmerDetails.AC_DC}
            </td>
          </tr>
          <tr className="bg-gray-100 border-b hover:bg-gray-300">
            <th className="text-left pl-6 text-gray-700 font-semibold">
              Block :
            </th>
            <td className="text-gray-700">{farmerDetails.block}</td>
            <th className="text-left pl-6 text-gray-700 font-semibold">
              Village :
            </th>
            <td className="text-gray-700">{farmerDetails.village}</td>
          </tr>
        </table>
      ) : (
        ""
      )}
      {farmerDetails && Object.keys(farmerDetails).length > 0 && (
        <form
          onSubmit={handleComplaintForm}
          className="w-full h-full p-4 sm:p-6"
        >
          <textarea
            rows={4}
            className="
                      block w-full
                      p-3 sm:p-4
                      text-sm sm:text-base
                      text-gray-900
                      bg-gray-50
                      rounded-sm
                      border border-gray-300
                      focus:ring-blue-500 focus:border-blue-500
                      resize-none
                    "
            placeholder="Enter Farmer Expire Details..."
            required
          ></textarea>

          <div className="grid gap-3 mt-4 sm:mt-6 md:grid-cols-4">
            {/* buttons / inputs */}
          </div>
        </form>
      )}
    </div>
  );
};

export default FarmerExpired;
